import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteTaskItem } from '../api/tasks';
import { notification } from 'antd';

export function useDeleteTaskItem(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteTaskItem(id),
    onSuccess: () => {
      notification.success({ message: 'Task deleted successfully' });
      void queryClient.invalidateQueries({ queryKey: ['taskItems'] });
      void queryClient.invalidateQueries({ queryKey: ['task-dashboard'] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to delete task' });
    },
  });
}
